module.exports = __webpack_public_path__ + "static/gallery27-9af65b8a41fe3cdebcc6a6b7b5027e31.png";